import React from 'react';
import { motion } from 'framer-motion';
import { valueOutcomes } from './landingConstants';
import './LandingValueSection.css';

const LandingValueSection: React.FC = () => {
  return (
    <section
      id="value"
      className="landing-value-section landing-section-equal py-8 sm:py-10 lg:py-14 bg-slate-950 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center max-w-3xl mx-auto mb-10 sm:mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="inline-flex items-center px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium bg-cyan-500/15 text-cyan-200 border border-cyan-400/20 mb-3 sm:mb-4">
            Why teams choose Agent Noda
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-100 mb-4">
            Outcomes that directly improve revenue workflow
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-slate-300">
            Designed for teams that want more qualified conversations, faster follow-up, and scalable outbound execution.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 sm:gap-6">
          {valueOutcomes.map((item, index) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: index * 0.06 }}
              className="landing-value-card"
            >
              <div className="h-10 w-10 rounded-lg bg-cyan-500/15 text-cyan-300 inline-flex items-center justify-center mb-3">
                <item.icon className="h-5 w-5" />
              </div>
              <h3 className="text-lg font-semibold text-slate-100 mb-2">{item.title}</h3>
              <p className="text-sm text-slate-300">{item.description}</p>
            </motion.article>
          ))}
        </div>

        <div className="mt-6 text-center">
          <a href="#" className="landing-back-to-top">
            Back to top
            <span aria-hidden="true">↑</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default LandingValueSection;
